module.exports = __webpack_public_path__ + "assets/img/gift-icon.b864a7e7.png";